import * as React from "react";
import { ContentPage } from "../../components/ContentPage";
import { DashboardApp } from "../DashboardApp/DashboardApp";
import { Sidebar } from "../../components/Sidebar";
import { useState } from "react";
import { PropositionsApp } from "../PropositionsApp/PropositionsApp";
import { EventsApp } from "../EventsApp/EventsApp";
import { GroupsApp } from "../GroupsApp/GroupsApp";
import { ThemesApp } from "../ThemesApp/ThemesApp";

type SelectedComponent =
  | "dashboard"
  | "eventos"
  | "temas"
  | "propostas"
  | "grupos"
  | null;

export default function HomeApp() {
  const [selectedComponent, setSelectedComponent] =
    useState<SelectedComponent>(null);

  const handleComponentChange = (component: SelectedComponent) => {
    setSelectedComponent(component);
  };

  return (
    <ContentPage>
      <div style={{ display: "flex" }}>
        <div style={{ flex: 1 }}>
          <Sidebar handleComponent={handleComponentChange} />
        </div>
        <div style={{ flex: 2 }}>
          <br></br>

          {selectedComponent === "dashboard" && <DashboardApp />}
          {selectedComponent === "eventos" && <EventsApp />}
          {selectedComponent === "temas" && <ThemesApp />}
          {selectedComponent === "propostas" && <PropositionsApp />}
          {selectedComponent === "grupos" && <GroupsApp />}
        </div>
      </div>
    </ContentPage>
  );
}
